import React, { useCallback, useEffect, memo } from 'react';
import { connect } from 'react-redux';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import Popups from '../../components/Popup';
import { getChanged } from '../../utils/ChangeSpy';
import { findUsers, changeField, makeContactLP, clearSuggest } from '../../actions/contact/contactLP';
import { reloadContactDetail } from '../../actions/contactDetail';
import { usePopupContext } from '../../contexts/PopupContext';

const onGetValue = suggestion => suggestion?.value ?? '';

const LPRolePopupContainer = ({
  children,
  contact,
  lp,
  user,
  findUsers,
  changeField,
  makeContactLP,
  reloadContactDetail,
}) => {
  const { closePopup } = usePopupContext();

  useEffect(() => {
    const module = {
      username: user.get('module') || '',
      id: user.get('moduleId') || 0,
    };

    changeField({ name: 'suggestRelation', value: module.username });
    changeField({ name: 'lpPrimaryRelId', value: module.id });
  }, [user, changeField]);

  const handleClose = useCallback(() => {
    closePopup();
  }, [closePopup]);

  const handleCreate = useCallback(() => {
    const id = contact.get('id', 0);
    const body = getChanged(lp);

    makeContactLP({ id, ...body }, () => {
      reloadContactDetail({ id }, handleClose);
    });
  }, [contact, lp, makeContactLP, reloadContactDetail, handleClose]);

  const handleChange = useCallback(
    event => {
      const { name, value } = event.target;

      changeField({ name, value });
    },
    [changeField],
  );

  const handleFetchUsers = useCallback(
    ({ value }) => {
      findUsers({ filter: value });
    },
    [findUsers],
  );

  const handleUpdateRelation = useCallback(
    param => {
      if ('text' in param) {
        changeField({ name: 'suggestRelation', value: param.text });
      }

      if ('suggestions' in param) {
        changeField({ name: 'suggests', value: param.suggestions });
      }
    },
    [changeField],
  );

  const handleSelectRelation = useCallback(
    (event, { suggestion }) => {
      changeField({ name: 'suggestRelation', value: suggestion.text });
    },
    [changeField],
  );

  const suggestRelation = {
    onFetch: handleFetchUsers,
    onUpdate: handleUpdateRelation,
    getValue: onGetValue,
    onSelect: handleSelectRelation,
    value: lp.get('suggestRelation', ''),
  };

  return (
    <>
      <Popups.LPRolePopup
        contact={contact}
        lp={lp}
        onChange={handleChange}
        onClose={handleClose}
        onCreate={handleCreate}
        suggestRelation={suggestRelation}
      />
      {children}
    </>
  );
};

function mapStateToProps(state, props) {
  return {
    ...props,
    contact: state.contact.info,
    lp: state.contact.lp,
    user: state.auth.get('user', null),
  };
}

export { LPRolePopupContainer };
export default connect(
  mapStateToProps,
  {
    makeContactLP,
    changeField,
    findUsers,
    clearSuggest,
    reloadContactDetail,
  },
  mergeProps,
  connectOptions,
)(memo(LPRolePopupContainer));
